import { cn } from "@babybjorn/ui";
import { Children, type FC, type PropsWithChildren } from "react";
import * as s from "./VariantList.module.scss";

type VariantListProp = PropsWithChildren<{
	variantAmount: number;
}>;

const VariantList: FC<VariantListProp> = ({ children, variantAmount }) => {
	const displayedVariants = Children.toArray(children).length;
	const hiddenVariantsAmount = variantAmount - displayedVariants;

	return (
		<>
			<ul className={cn(s.variantList)}>
				{children}
				{hiddenVariantsAmount > 0 && (
					<p>
						<span>&#43;</span>
						{hiddenVariantsAmount}
					</p>
				)}
			</ul>
		</>
	);
};

export default VariantList;
